import { useParams } from "react-router"
import './Stats.css';
import Header from "../components/Header";

export default function Stats() {
  const { eventId } = useParams();

  return (
    <>
      <header>
        <Header goBack={true} />
      </header>
      <div className="iframe-container">
        <div class="ras-content" data-provider="8924cc35-5d20-45f3-8e7e-dcddfc37b43d" data-event-id={eventId} data-isMobile="true" style={{height: '100%'}}>
        </div>
      </div>
    </>
  )
}
